import React, { useState, useEffect, useRef } from 'react';
import { Box, IconButton } from '@mui/material';

import { getThemeColor } from '../../../../../../utils/common';
import { Themes } from '../../../../../../constants';
import TrashIcon from '../../../../../../components/svgs/TrashIcon';

interface InstanceDurationProps {
  number: number;
  durationType?: string;
  colorTheme?: Themes;
  isDeletable: boolean;
  onDelete: () => void;
  testId?: number;
}

const InstanceDuration: React.FC<InstanceDurationProps> = (props: InstanceDurationProps) => {
  const {
    durationType = 'seconds',
    colorTheme = Themes.Primary,
    isDeletable,
    onDelete,
    testId,
  } = props;

  const [showDeleteIcon, setShowDeleteIcon] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleBlur = (event: MouseEvent) => {
    if (containerRef.current && event.target instanceof Node && !containerRef.current.contains(event.target)) {
      setShowDeleteIcon(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleBlur);
    return () => {
      document.removeEventListener('mousedown', handleBlur);
    };
  }, []);

  return (
    <Box
      data-testid={`instanceDurationAddedBox_${testId}`}
      ref={containerRef}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '70px',
        height: '40px',
        borderRadius: '4px',
        border: `2px solid ${getThemeColor(colorTheme).light2}`,
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: getThemeColor(colorTheme).primary,
      }}
      tabIndex={0}
      onClick={() => isDeletable && setShowDeleteIcon(true)}
    >
      {showDeleteIcon ? (
        <Box
          data-testid={`deleteInstanceDuration_instanceDurationAddedBox_${testId}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: getThemeColor(colorTheme).primary,
            borderRadius: '2px',
            width: '100%',
            height: '100%',
          }}
        >
          <IconButton onClick={() => isDeletable && onDelete()}>
            <TrashIcon color="white" />
          </IconButton>
        </Box>
      ) : (
        <>
          {props.number} {durationType === 'seconds' ? 's' : durationType === 'minutes' ? 'm' : 'h'}
        </>
      )}
    </Box>
  );
};

export default InstanceDuration;
